import Icon2 from '@/components/elements/icon/icon2';
import { IconName } from '@/components/elements/icon/icons';

interface BaseProps {
    icon: IconName;
    color?: string;
    sizeSm?: number;
    sizeMd?: number;
    className?: string;
    textClass?: string;
    iconClass?: string;
    testId?: string;
}

type WithText = { text: string; ariaLabel?: string };
type IconOnly = { text?: string; ariaLabel: string };

type Props = BaseProps & (WithText | IconOnly);

export default function IconText2({
    sizeSm = 4,
    sizeMd = 6,
    className = '',
    textClass = '',
    iconClass = '',
    ...props
}: Props) {
    return (
        <div className={`flex w-auto items-center gap-x-2 ${className}`}>
            <Icon2
                name={props.icon}
                color={props.color}
                ariaLabel={props.ariaLabel}
                iconClass={`h-${sizeSm ?? 4} w-${sizeSm ?? 4} md:h-${sizeMd ?? 6} md:w-${sizeMd ?? 6} ${iconClass}`}
            />
            {props.text && <span className={`md:text-regular w-fit text-sm ${textClass}`}>{props.text}</span>}
        </div>
    );
}
